import React, { ReactNode } from 'react';
import { getEnvironment } from '@unifocus/js-utils';
import classnames from 'classnames';

/**
 * {@docCategory NavBar}
 */
export interface NavBarProps {
   /**
    * The text to show in the center of the component
    */
   title: string;

   /**
    * Component to be displayed in the left section
    */
   leftContent?: ReactNode;

   /**
    * Component to be displayed in the right section
    */
   rightContent?: ReactNode;
}

export const NavBar = (props: NavBarProps) => {

   const environment = getEnvironment() || {};
   const mobileClassName = (environment.mobile) ? 'uf-nav-bar-mobile' : undefined;
   const className = classnames('uf-nav-bar', 'uf-nav-bar-default', mobileClassName);

   return (
      <div className={className}>
         <div className={'uf-nav-bar-left-container'}>
            {leftButton(props)}
         </div>

         <div className={'uf-nav-bar-title-container'}>
            {props.title}
         </div>

         <div className={'uf-nav-bar-right-container'}>
            {rightButton(props)}
         </div>
      </div>
   );
};

const leftButton = (props: NavBarProps) => {
   if (props.leftContent) {
      return props.leftContent;
   }

   return <div>&nbsp;</div>;
};

const rightButton = (props: NavBarProps) => {
   if (props.rightContent) {
      return props.rightContent;
   }

   return <div>&nbsp;</div>;
};
